import constant from "../../constant";
import router from "../../router";
const api = constant.api + "purchases";
// initial state
const state = () => ({
  all: [],
  purchases: [],
  items: [],
  allItems: [],
  purchase: {},
  report: [],
  errors: [],
});

// getters
const getters = {
  getAll: (state) => {
    return state.all;
  },
  getErrors: (state) => state.errors,
  getItems: (state) => state.items,
  getAllItems: (state) => state.allItems,
  getPurchase: (state) => {
    return state.purchase;
  },
  getReport: (state) => state.report,

  getPurchases: (state) => {
    return state.purchases;
  },
  totalPriceTTCItems: (state) => {
    return state.items.reduce(
      (acc, val) => acc + parseFloat(val.quantity) * parseFloat(val.priceTTC),
      0
    );
  },

  totalPriceHTItems: (state) => {
    return state.items.reduce(
      (acc, val) => acc + parseFloat(val.quantity) * parseFloat(val.priceHT),
      0
    );
  },

  totalQuantityItems: (state) => {
    return state.items.reduce((acc, val) => acc + parseFloat(val.quantity), 0);
  },
  numberItems: (state) => {
    return state.items.length;
  },

  getReportTotalQuantity: (state) =>
    state.report.reduce((acc, val) => acc + parseFloat(val.totalQuantity), 0),

  getReportTotalPriceTTC: (state) =>
    state.report.reduce((acc, val) => acc + parseFloat(val.totalPriceTTC), 0),

  getReportTotalPaid: (state) =>
    state.report.reduce((acc, val) => acc + parseFloat(val.amountPaid), 0),

  getReportTotalUnpaid: (state) =>
    state.report.reduce((acc, val) => acc + parseFloat(val.amountUnpaid), 0),
  // /

  getPurchasesTotalQuantity: (state) =>
    state.purchases.reduce(
      (acc, val) => acc + parseFloat(val.totalQuantity),
      0
    ),
  getPurchasesTotalPriceTTC: (state) =>
    state.purchases.reduce(
      (acc, val) => acc + parseFloat(val.totalPriceTTC),
      0
    ),
  getPurchasesTotalPaid: (state) =>
    state.purchases.reduce((acc, val) => acc + parseFloat(val.amountPaid), 0),
  getPurchasesTotalUnpaid: (state) =>
    state.purchases.reduce((acc, val) => acc + parseFloat(val.amountUnpaid), 0),
};

// actions
const actions = {
  async getAll({ commit }) {
    const purchases = await this.$api.fetch(api);
    commit("SET_PURCHASES", purchases);
  },

  async getAllItems({ commit }) {
    const items = await this.$api.fetch(api + "_items");
    commit("setItems", items);
  },

  async fetchAllItems({ commit }) {
    const items = await this.$api.fetch(api + "_items_all");
    commit("SET_ALL_ITEMS", items);
  },

  async getSupplierPurchasesUnpaid({ commit, dispatch }, supplier_reference) {
    try {
      if (!supplier_reference) {
        commit("SET_PURCHASES", []);
        return;
      }
      // Use $api.fetch from axios plugin which handles loading automatically
      const response = await this.$api.fetch(api + "_unpaid/" + supplier_reference);
      let purchases = Array.isArray(response) ? response : (response.data || response || []);
      commit("SET_PURCHASES", purchases);
    } catch (error) {
      console.error("Error fetching unpaid purchases:", error);
      commit("SET_PURCHASES", []);
      const errorMessage =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : "Erreur lors du chargement des achats impayés.";
      dispatch(
        "notification/store",
        {
          status: "error",
          message: errorMessage,
        },
        { root: true }
      );
    }
  },

  async filterItems({ commit }, data) {
    const response = await this.$api.instance.post(
      api + "_items_filter",
      data
    );
    commit("SET_ALL_ITEMS", response.data);
  },

  async show({ commit }, reference) {
    const response = await this.$api.show(api + "/" + reference);
    const purchase = response.data;
    commit("setPurchase", purchase);
  },

  async destroy({ }, reference) {
    const response = await this.$api.delete(api + "/" + reference);
    if (response && response.data && response.data.status === "success") {
      router.push({ name: "purchases-index" });
    }
  },

  async storeItem({ commit, dispatch }, data) {
    await this.$api.create(api + "_items", data).then((response) => {
      let status = response.data.status;

      if (status == "success") {
        commit("setItems", response.data.data);
      }
    });
  },

  async deleteItem({ commit, dispatch }, id) {
    const response = await this.$api.delete(api + "_items/" + id, {
      confirm: true, // UI likely already confirms; avoid double-confirm if needed
    });

    if (!response) return;

    const { status, message, data } = response.data;
    dispatch("notification/store", { status, message }, { root: true });
    if (status === "success") {
      commit("setItems", data);
    }
  },

  async store({ commit, dispatch }, data) {
    await this.$api.create(api, data).then((response) => {
      let status = response.data.status;

      if (status == "success") {
        commit("setPurchase", response.data.data);
        router.push({ name: "purchases-index" });
      }
    });
  },
  async update({ commit, dispatch }, data) {
    const response = await this.$api.update(
      api + "/" + data.reference,
      data,
      { confirm: true }
    );

    if (!response) return;

    const { status, message, data: purchase } = response.data;
    dispatch("notification/store", { status, message }, { root: true });
    if (status === "success" && purchase) {
      router.push({
        name: "purchases-details",
        params: {
          reference: purchase.reference,
        },
      });
    }
  },

  async updateItem({ commit, dispatch }, data) {
    try {
      const response = await this.$api.update(
        api + "_items/" + data.id,
        data,
        { confirm: true }
      );

      if (!response) return;

      const { status, message, data: items } = response.data;
      dispatch("notification/store", { status, message }, { root: true });
      if (status === "success") {
        commit("setItems", items);
      }
    } catch (error) {
      if (error.response) {
        const statusCode = error.response.status;
        let errorMessage = "Unprocessable Content";
        let errorMessages = [];

        if (error.response.data.errors) {
          // Construct an array of error messages from the errors object
          const errors = error.response.data.errors;
          for (const field in errors) {
            errorMessages.push(...errors[field]);
          }
          commit("SET_ERRORS", errorMessages);
          setTimeout(function () {
            commit("SET_ERRORS", []);
          }, 10000);
        }
        if (error.response.data.message) {
          errorMessage = error.response.data.message;
        }

        console.error("API Error:", errorMessage);

        // Dispatch the error notification along with status code and error messages array
        dispatch(
          "notification/store",
          { status: "error", message: errorMessage, statusCode, errorMessages },
          { root: true }
        );
      } else {
        console.error("An error occurred:", error.message);
      }
    }
  },

  async uploadSupplierOrder({ commit, dispatch }, reference) {
    await this.$api.instance
      .get(api + "_upload_supplier_order/" + reference)
      .then((response) => {
        let message = response.data.message;
        let status = response.data.status;

        dispatch("notification/store", { status, message }, { root: true });
        if (status == "success") {
          router.push({ name: "purchases-index" });
        }
      });
  },

  async applyInvoiceItems({ commit, dispatch }, payload) {
    try {
      const { items, supplier_name, invoice_number, date } = payload;
      const response = await this.$api.instance.post(api + "_apply_invoice_items", {
        items,
        supplier_name:  supplier_name  || "",
        invoice_number: invoice_number || "",
        date:           date           || "",
      }, {
        timeout: 60000,
      });
      if (response.data && response.data.data) {
        commit("setItems", response.data.data);
      }
      return response.data;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message)
          ? error.response.data.message
          : "Erreur lors de l'import des articles.";
      dispatch("notification/store", { status: "error", message }, { root: true });
      throw error;
    }
  },

  async parseInvoice({ dispatch }, data) {
    try {
      const response = await this.$api.instance.post(api + "_parse_invoice", data, {
        timeout: 90000,
      });
      return response.data;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message)
          ? error.response.data.message
          : "Erreur lors de l'analyse de la facture.";
      dispatch("notification/store", { status: "error", message }, { root: true });
      throw error;
    }
  },

  async filter({ dispatch, commit }, data) {
    const response = await this.$api.instance.post(api + "_filter", data);
    let purchases = response.data;
    commit("SET_PURCHASES", purchases);
  },
  async reportSupplier({ commit }, data) {
    const response = await this.$api.instance.post(
      api + "_supplier_report",
      data
    );
    let report = response.data;
    commit("SET_REPORT", report);
  },

  async printReportSupplier({ dispatch }, data) {
    try {
      dispatch(
        "notification/storeDownloading",
        {
          status: "success",
          message:
            "Le rapport détaillé du fournisseur est en cours de téléchargement. Veuillez patienter...",
        },
        { root: true }
      );
      const response = await this.$api.instance
        .post(api + "_supplier_report_print", data, {
          responseType: "blob", // Set the response type to 'blob' to handle binary data
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Rapport Fournisseur.pdf");
          link.click();
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  },
};

// mutations
const mutations = {
  SET_PURCHASES(state, purchases) {
    state.all = purchases;
    state.purchases = purchases;
  },
  async SET_ERRORS(state, errors) {
    state.errors = errors;
  },

  setItems(state, items) {
    state.items = items;
  },
  SET_ALL_ITEMS(state, data) {
    state.allItems = data;
  },
  setPurchase(state, purchase) {
    state.purchase = purchase;
  },
  SET_REPORT(state, report) {
    state.report = report;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
